import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function NavigationTracker() {
  const _location = useLocation();

  useEffect(() => {
    // Navigation tracking - can be expanded as needed
  }, []);

  return null;
}
